exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clickable[data-v-ea4b61f0]{cursor:pointer}.preferences[data-v-ea4b61f0]{font-size:1.6rem;line-height:1.7}", ""]);

// exports
